function GroupedTableSortButton(): JSX.Element {
    return (
        <div className="GroupedTableSortButton">
            a
        </div>
    );
}

export default GroupedTableSortButton;
